// extracted by mini-css-extract-plugin
export default {"table":"TestsTable-module__table__5rRMp","button":"TestsTable-module__button__zLNkI"};